'use strict';
/**
 * @author Maxim Seredkin
 */
export default function () {
    return {
        restrict: 'A',
        template: require('../view/project-maintenance-select.html'),
        transclude: true,
        scope: {
            projectMaintenance: '=myValue',
            projectMaintenances: '=myProjectMaintenances',
            mySize: '=?mySize',
            myFilters: '=?myFilters',
            myRequired: '=?myRequired',
            myDef: '=?myDef',
            myReadonly: '=?myReadonly'
        },
        controller: ['$scope', 'ProjectMaintenanceService',
            function ($scope, ProjectMaintenanceService) {

                $scope.select = select;
                $scope.clear = clear;

                // region Function

                function select() {
                    ProjectMaintenanceService.select($scope.projectMaintenance, $scope.projectMaintenances).result.then((data) => $scope.projectMaintenance = data);
                }

                function clear() {
                    $scope.projectMaintenance = null;
                }

                // endregion

            }]
    };
}
